// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Theme = require("./theme");
var React = require("react");
var Network = require("./network");
var SvgAnim = require("./svgAnim");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var BeepMp3 = require("./assets/beep-07.mp3");

((require('./testing.css')));

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.padding4(Css.px(0), Css.px(20), Css.px(2), Css.px(20)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var topIcon = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(20)),
      /* [] */0
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

function widerSecondaryGreenButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(180)),
              /* :: */[
                Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
                Theme.greenSecondaryButtonRaw
              ]
            ]);
}

var centerIcon = Css.style(/* :: */[
      Css.margin4(Css.px(30), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.transform(/* `scale */[
              -120664438,
              /* tuple */[
                1.2,
                1.2
              ]
            ]),
        /* [] */0
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* topIcon */topIcon,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* someLink */someLink,
  /* widerSecondaryGreenButton */widerSecondaryGreenButton,
  /* centerIcon */centerIcon
];

var JsAudio = /* module */[];

function text(prim) {
  return prim;
}

var component = ReasonReact.reducerComponent("Testing");

function make() {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function () {
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      return React.createElement("div", {
                  className: dashboard
                }, React.createElement("div", {
                      className: flexList
                    }, React.createElement("div", {
                          className: topIcon
                        }, ReasonReact.element(/* None */0, /* None */0, SvgAnim.make(/* array */[]))), React.createElement("h2", undefined, "Testing"), React.createElement("p", {
                          className: inputHeader
                        }, "Hier kannst du dein Trainingslevel ändern. Genaue Informationen zum Level und dem Punktemultiplikator findest du in deinem eBook."), React.createElement("button", {
                          className: widerSecondaryGreenButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* PlaySound */Block.__(1, [5]));
                            })
                        }, "Play Sound"), React.createElement("button", {
                          className: widerSecondaryGreenButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* LevelSelect */Block.__(0, [45]));
                            })
                        }, "Fortgeschritten"), React.createElement("button", {
                          className: widerSecondaryGreenButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* LevelSelect */Block.__(0, [60]));
                            })
                        }, "Profi"), React.createElement("a", {
                          className: someLink,
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* Reset */0);
                            })
                        }, "Reset"), React.createElement("button", {
                          className: Theme.simpleButton(/* () */0),
                          onClick: (function () {
                              return ReasonReact.Router[/* push */0]("/dashboard");
                            })
                        }, "Zurück")));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[/* levelSelect */0];
    });
  newrecord[/* reducer */12] = (function (action, _) {
      if (typeof action === "number") {
        return /* SideEffects */Block.__(2, [(function () {
                      Network.resetAll(/* () */0);
                      return ReasonReact.Router[/* push */0]("/wizard/1");
                    })]);
      } else if (action.tag) {
        return /* UpdateWithSideEffects */Block.__(3, [
                  /* record */[/* levelSelect */action[0]],
                  (function () {
                      var x = new Audio(BeepMp3);
                      x.play();
                      x.pause();
                      setTimeout((function () {
                              x.play();
                              return /* () */0;
                            }), 5000);
                      return /* () */0;
                    })
                ]);
      } else {
        var value = action[0];
        return /* UpdateWithSideEffects */Block.__(3, [
                  /* record */[/* levelSelect */value],
                  (function () {
                      Network.updateWizardResultToLS(value);
                      return ReasonReact.Router[/* push */0]("/dashboard");
                    })
                ]);
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.JsAudio = JsAudio;
exports.text = text;
exports.component = component;
exports.make = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/testing.re
// module id = 119
// module chunks = 0